import { API_BASE_URL, DEVICE_HTTP_URL } from '@/config/config'
import axios from "@/utils/axios";
import {request_type} from '@/utils/axios'

export const getOrderList = (params) => axios.get('merchant/order/getOrderList', {"params": {...params}})
export const getOrderListUrl = 'merchant/order/getOrderList'
//登陆
export const signIn = (params) => axios.post('merchant/auth/signIn', params)
// 记录打印次数
export const recordOrderPrintCount = (params) => axios.post('order/recordOrderPrintCount', params)
